import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../utils/auth.ts";
import Layout from "../../components/Layouts/Layout.tsx";
import OrganizationSettingsContent from "../../components/Settings/OrganizationSettingsContent.tsx";

export const Route = createFileRoute('/settings/organization')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <OrganizationSettingsContent />
    </Layout>
  );
}
